import * as Api from '@ViewModels';
import { ILeadInteraction } from '../../../viewModels/leads/interfaces';

// Analysis type configuration
export interface AnalysisType {
	key: string;
	label: string;
	systemMessage: string;
}

export const ANALYSIS_TYPES: AnalysisType[] = [
	{
		key: 'coaching',
		label: 'Post-Call Coaching',
		systemMessage: `You are an experienced sales manager providing structured feedback on Levitate SDR cold calls.

Use the Levitate six-step framework to analyze calls. Reference the knowledge documents for detailed heuristics, the decision tree, and SDR reply cues.

Pay particular attention to differentiating gatekeeper and decision-maker interactions in Step 1 by analyzing how the SDR speaks and handles introductions.

For each step present:
- Assess checkpoints from the knowledge doc,
- Provide Positives and Opportunities with supporting quotes (50 words max)
- Note omitted or incomplete steps explicitly.
- Offer one clear, actionable piece of feedback that aligns with the six-step framework.


Maintain a friendly, professional, and constructive tone throughout. Never give feedback not grounded in the Levitate framework or transcript evidence.

Conclude with a succinct, prioritized summary of key takeaways and next-call recommendations (about 100 words). Keep feedback targeted and focused on high-impact improvements`,
	},
];

// Filter interface for call analysis
export interface CallAnalysisFilter {
	date?: {
		startDate: Date;
		endDate: Date;
	};
	transcriptionStatus?: {
		label: string;
		value: string;
	};
	searchTerm?: string;
	analysisStatus?: 'analyzed' | 'not_analyzed' | 'all';
}

// Call context information for AI analysis
export interface CallContextInfo {
	// Call performance metrics
	duration: number;
	direction: string;
	callStatus: string;

	// Outcome information
	outcomeName?: string;
	outcomeDescription?: string;

	// Contact context
	contactJobTitle?: string;
	contactName?: string;

	// Company context
	companyName?: string;
	companyVertical?: string;
	companySize?: string;
	timeZone?: string;

	// Framework adherence
	ruleResults?: {
		name: string;
		message?: string;
		evaluationDuration: number;
	}[];
	selectedRule?: string;

	// Timing context
	callDate: string;
	callTime: string;

	// SDR context
	sdrName?: string;
	sdrEmail?: string;
}

// Extended phone call data for analysis
export interface CallAnalysisData {
	phoneCall: Api.IPhoneCall;
	company?: Api.ICompany;
	contact?: Api.IContact;
	creator?: Api.IUserReference; // SDR who made the call
	interaction?: ILeadInteraction; // Contains outcome data
	transcription?: Api.ITranscription;
	hasTranscription: boolean;
	analysisStatus?: 'pending' | 'completed' | 'failed';
	contextInfo?: CallContextInfo; // Structured context for AI analysis
}
